import React, { useContext } from "react";
import { Bell } from "lucide-react";
import useDBO from "../content/hooks/useDBO";
import { UserContext } from "../../Context";
import "./notification-premium.css";

/**
 * NotificationButton - Button to show notifications with badge
 * Uses lucide-react Bell icon instead of emoji.
 *
 * @param {object} props Component props
 * @param {function} props.showNotifications Function to show notifications
 * @param {string} props.menuId Menu ID for accessibility
 * @author Forge
 * @date 2026-04-07
 * @version 3.0
 */
export default function NotificationButton({ showNotifications, menuId }) {
  const { user } = useContext(UserContext);
  const number = useDBO(`/users/${user._id}/notificationCount`, 20);

  if (number.loading) return <></>;
  if (number.error) return <></>;

  return (
    <button
      className="notification-button"
      onClick={showNotifications}
      aria-label="Show notifications"
      aria-controls={menuId}
      type="button"
    >
      <Bell size={18} className="notification-button-icon" />
      {number.get.count > 0 && (
        <span className="notification-badge">
          {number.get.count}
        </span>
      )}
    </button>
  );
}
